import { render, staticRenderFns } from "./RappiCategory.vue?vue&type=template&id=5fa155c9"
import script from "./RappiCategory.vue?vue&type=script&lang=js"
export * from "./RappiCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports